// // import React from "react";
// // import Container from "@mui/material/Container";
// // import Box from "@mui/material/Box";

// // export default function AuthLayout({ children }) {
// //   return (
// //     <Container maxWidth="sm">
// //       <Box
// //         sx={{
// //           minHeight: "100vh",
// //           display: "flex",
// //           alignItems: "center",
// //         }}
// //       >
// //         <Box sx={{ width: "100%" }}>{children}</Box>
// //       </Box>
// //     </Container>
// //   );
// // }
// // src/components/AuthLayout.jsx
// import React from "react";
// import Box from "@mui/material/Box";
// import Container from "@mui/material/Container";
// import Paper from "@mui/material/Paper";

// export default function AuthLayout({ children, backgroundImage }) {
//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         backgroundImage: `url(${backgroundImage})`,
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         p: 2,
//       }}
//     >
//       <Container maxWidth="sm">
//         <Paper
//           elevation={6}
//           sx={{
//             p: { xs: 3, sm: 5 },
//             borderRadius: 3,
//             backdropFilter: "blur(6px)",
//             backgroundColor: "rgba(255,255,255,0.8)",
//           }}
//         >
//           {children}
//         </Paper>
//       </Container>
//     </Box>
//   );
// }

// src/components/AuthLayout.jsx
import React from "react";
import { Box, Container, Paper, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

// Dark abstract backgrounds from Unsplash (free to use)
const BG_DESKTOP = "https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?w=1920&q=80&auto=format&fit=crop";
const BG_MOBILE = "https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?w=800&q=80&auto=format&fit=crop";

export default function AuthLayout({ children }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundImage: `url(${isMobile ? BG_MOBILE : BG_DESKTOP})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        p: { xs: 2, sm: 4 },
        position: "relative",
        // Dark overlay to ensure readability
        "&::before": {
          content: '""',
          position: "absolute",
          inset: 0,
          background: "rgba(0, 0, 0, 0.55)",
          zIndex: 1,
        },
      }}
    >
      {/* Logo Text */}
      <Typography
        sx={{
          mb: { xs: 3, sm: 4 },
          fontSize: { xs: "1.8rem", sm: "2.2rem", md: "2.5rem" },
          fontWeight: 700,
          letterSpacing: 1,
          zIndex: 2,
        }}
      >
        <Box component="span" sx={{ color: "#fff" }}>Work</Box>
        <Box component="span" sx={{ color: "#C4A574" }}>Pilot</Box>
      </Typography>

      {/* Main Auth Content */}
      <Container maxWidth="sm" sx={{ position: "relative", zIndex: 2 }}>
        <Paper
          elevation={6}
          sx={{
            p: { xs: 3, sm: 5 },
            borderRadius: 3,
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            boxShadow: "0 8px 32px rgba(0,0,0,0.5)",
            backdropFilter: "blur(16px)",
            border: "1px solid rgba(196, 165, 116, 0.25)",
          }}
        >
          {children}
        </Paper>
      </Container>

      {/* Footer */}
      <Typography
        variant="caption"
        sx={{
          position: "absolute",
          bottom: { xs: 10, sm: 14 },
          left: 0,
          right: 0,
          textAlign: "center",
          color: "#fff",
          fontSize: { xs: "0.8rem", sm: "0.95rem" },
          fontWeight: 600,
          letterSpacing: 1,
          pointerEvents: "none",
          userSelect: "none",
          zIndex: 2,
        }}
      >
        Developed By H M IT Solutions
      </Typography>
    </Box>
  );
}
